export const BOOK_FLIGHT = "BOOK_FLIGHT";
export const DELETE_FLIGHT = "DELETE_FLIGHT";
